import { createAsyncThunk } from '@reduxjs/toolkit';

import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { locationPopupActions } from '@/microfrontends/filters/shared/store/slices/locationPopup';
import { searchMetaActions } from '@/microfrontends/filters/shared/store/slices/searchMeta';

import { applyFilters } from '../applyFilters';
import { applyLocation } from '../geo/applyLocation';

export const applySelectedLocation = createAsyncThunk<void, undefined, TThunkApi>(
  'locationPopup/applySelectedLocation',
  async (_, thunkApi) => {
    const { getState, dispatch } = thunkApi;
    const state = getState();

    const location = state.locationPopup.selectedCity || state.locationPopup.selectedRegion;

    // Синхронизируем состояние, jsonQuery и meta, которые были получены в модальном окне.
    // Переносим их в состояние фильтров. При этом meta переносить не обязательно,
    // но лучше перенести, во избежание багов
    dispatch(applyLocation(location));
    dispatch(searchMetaActions.set(state.locationPopup.meta.data));

    dispatch(applyFilters());
    dispatch(locationPopupActions.close());
  },
);
